import io from "socket.io-client";
import {SocketServer} from "@/services/SocketServer";
const socket = io.connect(SocketServer, {path: '/socketApi/socket.io'})
//const socket = io.connect(SocketServer)
const SERECT_KEY = 'appSecretPassCodePolycom'
const captchaCompare = (Validator) => {
    Validator.extend('compare_captcha', (value, {server_captcha}) => {
      return value === server_captcha
    }, {
      paramNames: ['server_captcha']
    });
  }
  
const ONGOING_CONF_SORT_BY_NAME = 'name'
const ONGOING_CONF_SORT_BY_MIC = 'audioMute'
const ONGOING_CONF_SORT_BY_VIDEO = 'videoMute'
const ONGOING_CONF_SORT_BY_SIGNAL = 'signalingProtocol'
const ONGOING_CONF_SORT_BY_AUDIO_IN = 'audio_in'
const ONGOING_CONF_SORT_BY_AUDIO_OUT = 'audio_out'
const ONGOING_CONF_SORT_BY_VIDEO_IN = 'video_in'
const ONGOING_CONF_SORT_BY_VIDEO_OUT = 'video_out'
const ONGOING_CONF_SORT_BY_AUDIO_ENDPOINT = 'audioMuteEndpoint'
const ONGOING_CONF_SORT_BY_AUDIO_BLOCK = 'audioBlock'
const ONGOING_CONF_SORT_BY_VOLUME = 'volume'
const ONGOING_CONF_SORT_BY_LISTEN_VOLUME = 'listenVolume'
const ONGOING_CONF_SORT_BY_SPEAKER = 'speaker'
const ONGOING_CONF_SORT_BY_LECTURER = 'lecturer'
const ONGOING_CONF_SORT_BY_EXCLUSIVE_CONTENT = 'isExclusiveContent'
const ONGOING_CONF_SORT_BY_SHARE_CONTENT = 'shareContent'
const ONGOING_CONF_SORT_BY_HANDUP = 'isHandup'
const ONGOING_CONF_SORT_BY_ORDER = 'index'
const ONGOING_CONF_SORT_BY_CONTENT_IN = 'content_in'
const ONGOING_CONF_SORT_BY_CONTENT_OUT = 'content_out'
const ONGOING_CONF_SORT_BY_CONNECTION_STATUS = 'connectionStatus'

export {socket, SERECT_KEY, captchaCompare, ONGOING_CONF_SORT_BY_NAME, ONGOING_CONF_SORT_BY_MIC, ONGOING_CONF_SORT_BY_VIDEO, ONGOING_CONF_SORT_BY_SIGNAL, ONGOING_CONF_SORT_BY_AUDIO_IN, ONGOING_CONF_SORT_BY_AUDIO_OUT, ONGOING_CONF_SORT_BY_VIDEO_IN, ONGOING_CONF_SORT_BY_VIDEO_OUT, ONGOING_CONF_SORT_BY_AUDIO_ENDPOINT, ONGOING_CONF_SORT_BY_AUDIO_BLOCK, ONGOING_CONF_SORT_BY_VOLUME, ONGOING_CONF_SORT_BY_LISTEN_VOLUME, ONGOING_CONF_SORT_BY_SPEAKER, ONGOING_CONF_SORT_BY_LECTURER, ONGOING_CONF_SORT_BY_EXCLUSIVE_CONTENT, ONGOING_CONF_SORT_BY_SHARE_CONTENT, ONGOING_CONF_SORT_BY_HANDUP, ONGOING_CONF_SORT_BY_ORDER, ONGOING_CONF_SORT_BY_CONTENT_IN, ONGOING_CONF_SORT_BY_CONTENT_OUT, ONGOING_CONF_SORT_BY_CONNECTION_STATUS}